<script setup lang="ts">
import { inputNumberProps } from 'naive-ui';

const props = defineProps(inputNumberProps);
</script>

<template>
  <!-- Themed n-input-number (shares the Input theme section) — a numeric
       extracted value, a page number, a repeat interval. -->
  <n-input-number v-bind="props">
    <template v-if="$slots.prefix" #prefix><slot name="prefix" /></template>
    <template v-if="$slots.suffix" #suffix><slot name="suffix" /></template>
  </n-input-number>
</template>
